import gql from "graphql-tag";

export const REDEEM_CODE_MUTATION = gql`
  mutation RedeemCode($input: RedeemCodeInput!) {
    redeemCode(input: $input) {
      status
    }
  }
`;
